import { render } from "./errormessage.vue?vue&type=template&id=ef2f3f3a"
import script from "./errormessage.vue?vue&type=script&lang=js"
export * from "./errormessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__